import { useTranslation } from 'react-i18next'
import type { DiagnosticAssignmentRow } from '@/api/adminDiagnostics'
import { ModalShell } from './ModalShell'

interface Props {
  history: DiagnosticAssignmentRow[]
  studentName: string
  onClose: () => void
  onViewResult: (a: DiagnosticAssignmentRow) => void
}

export function HistoryModal({ history, studentName, onClose, onViewResult }: Props) {
  const { t } = useTranslation('admin')
  const hasResult = (a: DiagnosticAssignmentRow) => a.status === 'COMPLETED' || a.status === 'LEVEL_GRADING'

  return (
    <ModalShell title={t('diagnostic.history.title', { name: studentName })} onClose={onClose}>
      {history.length === 0 ? (
        <p className="text-sm text-gray-500">{t('diagnostic.history.empty')}</p>
      ) : (
        <ul className="divide-y divide-gray-100">
          {history.map((a) => (
            <li key={a.id} data-testid="history-row" className="py-2 flex items-center gap-2 text-sm">
              <span className="font-medium text-gray-800">
                {t('diagnostic.history.roundBadge', { round: a.roundNo })}
              </span>
              <span className="text-gray-600">{t(`diagnostic.status.${a.status}`)}</span>
              {a.aiqCarried && (
                <span data-testid={`carry-aiq-${a.id}`} className="px-1.5 py-0.5 rounded bg-amber-50 text-amber-600 text-xs">
                  {t('diagnostic.history.aiqCarried')}
                </span>
              )}
              {a.levelCarried && (
                <span data-testid={`carry-level-${a.id}`} className="px-1.5 py-0.5 rounded bg-amber-50 text-amber-600 text-xs">
                  {t('diagnostic.history.levelCarried')}
                </span>
              )}
              {hasResult(a) && (
                <button data-testid={`history-result-${a.id}`} type="button" onClick={() => onViewResult(a)}
                  className="ml-auto text-primary-600 hover:underline">
                  {t('diagnostic.history.viewResult')}
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
      <div className="flex justify-end mt-4">
        <button type="button" onClick={onClose} className="px-4 py-2 rounded-lg border border-gray-300 text-sm">
          {t('diagnostic.history.close')}
        </button>
      </div>
    </ModalShell>
  )
}
